const normalizeRating = (rating) => {
  return rating.toLowerCase().replace(/\s+/g, '_');
};

const getAltText = (rating) => {
  const MAX_RATING = 5;
  const baseText = `Food Hygiene Rating: `;
  if (!isNaN(parseInt(rating.name))) {
    return `${baseText}${rating.name} out of ${MAX_RATING}, ${rating.alt}`;
  }
  return `${baseText}${rating}`;
};

const FHRS_MAP = {
  0: { name: '0', alt: 'Urgent Improvement Necessary' },
  1: { name: '1', alt: 'Major Improvement Necessary' },
  2: { name: '2', alt: 'Improvement Necessary' },
  3: { name: '3', alt: 'Generally Satisfactory' },
  4: { name: '4', alt: 'Good' },
  5: { name: '5', alt: 'Very Good' },
  exempt: 'exempt',
  awaiting_publication: 'awaitingpublication',
  awaiting_inspection: 'awaitinginspection',
};

const FHIS_MAP = {
  awaiting_inspection: 'awaiting_inspection',
  awaiting_publication: 'awaiting_publication',
  exempt: 'exempt',
  improvement_required: 'improvement_required',
  pass_and_eat_safe: 'pass_and_eat_safe',
  pass: 'pass',
};

export const getFoodHygieneRatingBadge = async (rating, country) => {
  if (!country || rating == null) return null;

  if (country.toLowerCase() === 'england') {
    const _rating = FHRS_MAP[normalizeRating(rating)];
    if (!_rating) return null;

    const src = await import(`./fhrs/fhrs_${_rating.name || _rating}_en-gb.svg`);
    return {
      src: src.default,
      alt: getAltText(_rating),
    };
  }
  if (country.toLowerCase() === 'scotland') {
    const _rating = FHIS_MAP[normalizeRating(rating)];
    if (!_rating) return null;

    const src = await import(`./fhis/fhis_${_rating}.jpg`);
    return {
      src: src.default,
      alt: getAltText(_rating),
    };
  }
};
